import { render, staticRenderFns } from "./BlocoDadosTabsMapaMonitoramentoAgricola.vue?vue&type=template&id=c79cf7f4&lang=pug"
import script from "./BlocoDadosTabsMapaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoDadosTabsMapaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoDadosTabsMapaMonitoramentoAgricola.vue?vue&type=style&index=0&id=c79cf7f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports